export default {
  path: '/trackers/overview',
  name: 'Trackers',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackersView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
